var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#322670"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0912 39.1412C24.2866 39.4181 24.6129 39.5813 24.9587 39.5813C25.3045 39.5813 25.6307 39.4182 25.8262 39.1412C26.4998 38.187 27.2784 37.1569 28.0973 36.0736C29.8404 33.7677 31.7658 31.2205 33.2482 28.6507C34.9939 25.6245 35.8525 23.0268 35.8525 20.7158C35.8525 15.0299 30.9575 10.4188 24.9587 10.4188C18.9599 10.4188 14.0648 15.0299 14.0648 20.7158C14.0648 23.0268 14.9235 25.6245 16.6692 28.6507C18.151 31.2194 20.0796 33.771 21.8234 36.0781C22.6418 37.1608 23.4195 38.1897 24.0912 39.1412ZM24.9587 12.4099C29.8208 12.4099 33.7619 16.144 33.7619 20.7158C33.7619 22.6626 33.002 24.9421 31.4159 27.6918C29.995 30.155 28.114 32.6433 26.3957 34.9164C25.898 35.5748 25.414 36.2151 24.9587 36.8316C24.5035 36.2152 24.0195 35.5749 23.5218 34.9166C21.8036 32.6436 19.9225 30.1551 18.5015 27.6918C16.9154 24.9421 16.1555 22.6626 16.1555 20.7158C16.1555 16.144 20.0965 12.4099 24.9587 12.4099Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9579 25.9392C27.9946 25.9392 30.4798 23.6041 30.4798 20.7158C30.4798 17.8274 27.9946 15.4923 24.9579 15.4923C21.9211 15.4923 19.4359 17.8274 19.4359 20.7158C19.4359 23.6041 21.9211 25.9392 24.9579 25.9392ZM24.9579 17.4834C26.8579 17.4834 28.3891 18.9415 28.3891 20.7158C28.3891 22.49 26.8579 23.9481 24.9579 23.9481C23.0578 23.9481 21.5266 22.49 21.5266 20.7158C21.5266 18.9415 23.0578 17.4834 24.9579 17.4834Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.c6543a29b0e39a5a50d88449f1b192d5.svg";
export { ForwardRef as ReactComponent };